export const yesNoOptions = [
	{ value: true, label: "Yes" },
	{ value: false, label: "No" },
];
